import { useEffect } from 'react';
import { useStore } from '@hmpu/powerups.store';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { getRegionLocaleLangs } from '../../../../services/getRegionLocaleLangs';
import './LanguageSettings.css';

export function LanguageSettings() {
  const { __t } = useTranslation('LANGUAGE_SETTINGS');
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const pageTitle = __t('pageTitle');
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);
  const currLocale = useStore((state) => state.locale);

  const regionLocaleLangs = getRegionLocaleLangs(currLocale);

  useEffect(() => {
    const backButton = document.querySelector("#SettingsPanel-Back") as HTMLElement | null;
    if (backButton) {
      backButton.focus();
    }   
    setPageTitle(pageTitle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  return (
    <section className="SettingsPanel-Container">
      <h1 tabIndex={0}>{__t('h1')}</h1>
      <ul className="SettingsPanel-Container LanguagePanel">
        {regionLocaleLangs.languages.map(((obj) => {
          const targetUrl = new URL(window.location.href);
          targetUrl.searchParams.set('locale', obj.locale);
          const isCurrent = obj.locale === currLocale;
            return (<li key={obj.locale}>
              <a
                href={targetUrl.toString()}
                // eslint-disable-next-line jsx-a11y/aria-proptypes
                aria-current={`${isCurrent ? 'true' : 'false'}`}
                className={`${isCurrent ? 'current-locale' : ''}`}
                rel="alternate"
                hrefLang={obj.targetLang}
                lang={obj.targetLang}
              >
                <span lang={obj.targetLang} dir={obj.dir}>{obj.displayName}</span>
                <div className="lang-check">
                  {obj.locale === currLocale && <span className="check"></span>}
                </div>
              </a>
            </li>)

        }))}
        </ul>
    </section>
  );
}